export const DAILY_SETTLEMENT_ERROR_MESSAGES = {
  INVALID_PARAMETERS: 'Los filtros enviados no son válidos.',
  INVALID_DATE: 'Selecciona una fecha válida.',
  FUTURE_DATE: 'No se permiten fechas futuras.',
  INVALID_STATUS: 'Selecciona un estado de liquidación válido.',
  INVALID_SORT_COLUMN: 'La columna seleccionada para ordenar no es válida.',
  INVALID_SORT_DIRECTION: 'El orden seleccionado no es válido.',
  INVALID_PAGE: 'La página solicitada no es válida.',
  INVALID_PER_PAGE: 'La cantidad de usuarios por página no es válida.',
  MISSING_COLLECTOR: 'Selecciona un usuario para consultar sus cobros.',
  COLLECTOR_NOT_FOUND: 'No se encontró el usuario solicitado.',
  SHARED_COLLECTOR_IDENTITY: 'La identidad de un cobrador está compartida entre empresas.',
  DUPLICATE_SETTLEMENT: 'Un cobro está asociado a más de una liquidación.',
  INVALID_CHARGE_DATA: 'Hay cobros con importes o fechas inconsistentes.',
  FORBIDDEN: 'No tienes permiso para consultar el control diario.'
}

export const DAILY_SETTLEMENT_HTTP_ERROR_MESSAGES = {
  401: 'Tu sesión no está disponible. Vuelve a iniciar sesión.',
  403: DAILY_SETTLEMENT_ERROR_MESSAGES.FORBIDDEN,
  404: 'No se encontró la información solicitada.',
  409: 'Hay una inconsistencia en los datos del control diario.',
  422: 'Revisa los filtros enviados y vuelve a intentar.',
  500: 'No se pudo cargar el control diario. Vuelve a intentar.',
  503: 'El control diario no está disponible. Vuelve a intentar.'
}

export const DAILY_SETTLEMENT_ERROR_DEFAULT =
  'No se pudo cargar el control diario. Vuelve a intentar.'
